/**************************************************
 * Nombre:       Tarjeta_Formacion_Item
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import billete from '../../Recursos/Iconos/ic_billete.svg'
import {NEGRITA} from "../../Constantes";
import {theme} from "../../Tema";


const Tarjeta_Formacion_Item = ({item}) => {

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>


            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}>

                <Grid container size={{xs: 12, sm: 12, md: 2}} sx={{justifyContent: 'flex-start'}}>
                    <img src={billete} width="90%" height="auto"/>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 10}} sx={{justifyContent: 'flex-start'}}>
                    <Typography sx={{fontSize: 18, fontWeight: 400}}>Valor programa</Typography>
                </Grid>

            </Grid>


            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <Typography
                    sx={{fontSize: 32, fontWeight: 600, color: theme.palette.primary.main, fontFamily: NEGRITA, lineHeight: 1.1}}>$
                    2.500.000</Typography>
            </Grid>


        </Grid>
    )

}
export default Tarjeta_Formacion_Item